import { FC, createContext } from "react";

export type Cache = {
  initialized: boolean,
  // 前回の検索条件・ソート順・表示ページ番号を継承して、一覧画面の検索結果を再リクエストするか
  // (リストアイテムの新規追加・表示内容の編集・削除が行なわれた場合のみ true)
  isFlushView: boolean,
  topPage: string,
  value: object,
  saveTopPage: (topPage: string) => void,
  removeTopPage: () => void,
};

const KEY_TOP_PAGE = "mdmTopPage";

const cache = {
  initialized: false,
  isFlushView: false,
  topPage: localStorage.getItem(KEY_TOP_PAGE) === null ? "" : localStorage.getItem(KEY_TOP_PAGE) + "",
  value: {},
  saveTopPage: (topPage: string) => {
    localStorage.setItem(KEY_TOP_PAGE, topPage);
  },
  removeTopPage: () => {
    localStorage.removeItem(KEY_TOP_PAGE);
  },
};

export const UserContext = createContext<Cache>(cache);

export const UserProvider: FC<{}> = (props) => {
  return (
    <UserContext.Provider value={cache}>
      {props.children}
    </UserContext.Provider>
  );
};
